import { SearchInput } from "@src/features/table_filtering/components/search_input";
import { DatePicker } from "antd";
import dayjs from "dayjs";

interface ChangelogTabToolBarProps {
  onQuickFilter: (quickSearch: string) => void;
  disabled: boolean;
  selectedMonth?: string | undefined;
  onMonthChange?: (month: string | undefined) => void;
}

const ChangelogTabToolBar: React.FC<ChangelogTabToolBarProps> = ({
  onQuickFilter,
  disabled,
  selectedMonth,
  onMonthChange = () => {},
}) => {
  const dateFormat = "YYYY-MM";

  return (
    <div className="tool-bar">
      <div className="tool-bar__button-section">
        <SearchInput
          onChange={onQuickFilter}
          disabled={disabled}
          title="changelog"
        />
        <DatePicker
          picker="month"
          value={dayjs(selectedMonth, dateFormat)}
          onChange={(date) => {
            onMonthChange(date.format(dateFormat));
          }}
          disabled={disabled}
          allowClear={false}
          maxDate={dayjs()}
          style={{ width: "160px" }}
          data-testid="date-selection"
        />
      </div>
    </div>
  );
};

export default ChangelogTabToolBar;
